import moment from 'moment';

const convertMillisecodToYears = time => {
    if (time || time === 0) {
        const years = moment.duration(time).years();
        const months = moment.duration(time).months();
        return `${years} ${years > 1 ? '[YEARS]' : '[YEAR]'}  [AND] ${months} ${months > 1 ? '[MONTHS]' : '[MONTH]'}`;
    } else {
        return null;
    }
};

const convertMillisecodToMonths = time => {
    if (time || time === 0) {
        const months = moment.duration(time).months();
        const days = moment.duration(time).days();
        return `${months} ${months > 1 ? '[MONTHS]' : '[MONTH]'}  [AND] ${days} ${days > 1 ? '[DAYS]' : '[DAY]'}`;
    } else {
        return null;
    }
};

const convertMillisecodToDays = time => {
    if (time || time === 0) {
        const days = moment.duration(time).days();
        const hours = moment.duration(time).hours();
        return `${days} ${days > 1 ? '[DAYS]' : '[DAY]'}  [AND] ${hours} ${hours > 1 ? '[HOURS]' : '[HOUR]'}`;
    } else {
        return null;
    }
};

const convertMillisecodToHours = time => {
    if (time || time === 0) {
        const hours = moment.duration(time).hours();
        const minutes = moment.duration(time).minutes();
        return `${twoDecimals(hours)} : ${twoDecimals(minutes)} hrs`;
    } else {
        return null;
    }
};

const convertMillisecodToMinutes = time => {
    if (time || time === 0) {
        const minutes = moment.duration(time).minutes();
        return `${minutes} ${minutes === 1 ? '[MINUTE]' : '[MINUTES]'}`;
    } else {
        return null;
    }
};

const convertMillisecodToSeconds = time => {
    if (time || time === 0) {
        const seconds = moment.duration(time).seconds();
        return `${seconds} ${seconds === 1 ? '[SECOND]' : '[SECONDS]'}`;
    } else {
        return null;
    }
};

export const getDifferenceDate = (date1, date2 = Date.now()) => {
    const time = moment(date2)
        .diff(date1)
        .valueOf();

    const years = moment.duration(time).years();
    const months = moment.duration(time).months();
    const days = moment.duration(time).days();
    const hours = moment.duration(time).hours();
    const minutes = moment.duration(time).minutes();

    if (years > 0) {
        return convertMillisecodToYears(time);
    } else if (months > 0) {
        return convertMillisecodToMonths(time);
    } else if (days > 0) {
        return convertMillisecodToDays(time);
    } else if (hours > 0) {
        return convertMillisecodToHours(time);
    } else if (minutes > 0) {
        return convertMillisecodToMinutes(time);
    } else {
        return convertMillisecodToSeconds(time);
    }
};

const twoDecimals = time => ('00' + time).slice(-2);
